var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmakerSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "-10 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bookmaker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 24.44c-0.2 0-0.4-0.080-0.56-0.24l-4.68-4.28-4.68 4.28c-0.24 0.24-0.6 0.28-0.92 0.16-0.28-0.12-0.48-0.44-0.48-0.76v-15.2c0-0.48 0.36-0.84 0.84-0.84h10.44c0.48 0 0.84 0.36 0.84 0.84v15.2c0 0.32-0.2 0.64-0.52 0.76 0 0.040-0.2 0.080-0.28 0.080zM1.68 9.24v12.44l3.84-3.52c0.32-0.28 0.8-0.28 1.12 0l3.84 3.52v-12.44h-8.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmakerSvgrepoCom);
export default __webpack_public_path__ + "static/media/bookmaker-svgrepo-com.6ac712f2f8ceae61ed37fb001b79647a.svg";
export { ForwardRef as ReactComponent };